// extracted by mini-css-extract-plugin
export default {"hide-search-button":"style_hide-search-button__emqal"};